import { ContentField, contentFieldCopy, type DeliveryKind } from "@/components/ListingFields/ContentField";
import { EditorSection } from "@/components/ListingFields/EditorSectionHeader";

export interface ProductContentEditorProps {
  /** Selected delivery mode. */
  deliveryKind: DeliveryKind;
  /** Current delivery URL for the link input. */
  deliveryUrl: string;
  /** File field error; when present the drop field renders invalid. */
  fileError?: string;
  /** Name of the attached or just-picked file, if any. */
  fileName?: string;
  /** Size in bytes of the just-picked file, if any. */
  fileSize?: number;
  /** Whether a direct upload is in flight. */
  isUploading: boolean;
  /** Link field error; when present the input renders invalid. */
  linkError?: string;
  /** Fires on link input change with the new value. */
  onDeliveryUrlChange: (value: string) => void;
  /** Clears the currently attached file. */
  onFileRemove: () => void;
  /** Fires with the chosen `File` to begin the upload. */
  onFileSelect: (file: File) => void;
  /** Fires when the delivery mode changes (raw string from the radio group). */
  onKindChange: (value: string) => void;
  /** Upload progress, 0–100. */
  progress: number;
}

export function ProductContentEditor({
  deliveryKind,
  deliveryUrl,
  fileError,
  fileName,
  fileSize,
  isUploading,
  linkError,
  onDeliveryUrlChange,
  onFileRemove,
  onFileSelect,
  onKindChange,
  progress,
}: ProductContentEditorProps) {
  return (
    <EditorSection {...contentFieldCopy()}>
      <ContentField
        deliveryKind={deliveryKind}
        deliveryUrl={deliveryUrl}
        fileError={fileError}
        fileName={fileName}
        fileSize={fileSize}
        isUploading={isUploading}
        linkError={linkError}
        onDeliveryUrlChange={onDeliveryUrlChange}
        onFileRemove={onFileRemove}
        onFileSelect={onFileSelect}
        onKindChange={onKindChange}
        progress={progress}
        // The section pane is narrower than the wizard's centred stage.
        size="3xl"
      />
    </EditorSection>
  );
}
